import { UserEditComponent } from './user-edit.component';

export default UserEditComponent;
